<template>
  <div class="technical-support">
    <div class="technical-support__header">
      <div class="header__title">
        <span>Ми завжди готові відповісти на ваші запитання!</span>
      </div>
      <div class="header__description">
        <span
          >Для отримання консультації, усунення багів або вирішення питань під
          час роботи з кабінетом ви можете звернутися до наших фахівців за
          допомогою зворотного зв'язку.</span
        >
      </div>
    </div>
    <div class="technical-support__body">
      <div class="body__title">
        <span>Також ви можете зв'язатися з нами за допомогою мессенджерів</span>
      </div>
      <div class="body__messengers">
        <div class="telegram">
          <div class="label">
            <span>Telegram</span>
          </div>
          <div class="icon">
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35 17.5C35 27.1687 27.1687 35 17.5 35C7.83125 35 0 27.1687 0 17.5C0 7.83125 7.83125 0 17.5 0C27.1687 0 35 7.83125 35 17.5Z"
                fill="url(#paint0_linear_10724_9191)"
              />
              <path
                d="M14.261 20.5825L20.1943 24.8243C20.8686 25.1808 21.3589 25.0026 21.5306 24.2184L23.9456 13.192C24.1907 12.2296 23.5655 11.8019 22.9158 12.087L8.74455 17.3863C7.7761 17.7665 7.78836 18.2893 8.57293 18.5151L12.2138 19.6201L20.6357 14.4753C21.0279 14.2376 21.3957 14.3683 21.1015 14.6297L14.261 20.5825Z"
                fill="url(#paint1_linear_10724_9191)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_10724_9191"
                  x1="22.629"
                  y1="5.53146"
                  x2="13.879"
                  y2="25.9478"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#78D1F8" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_10724_9191"
                  x1="17.815"
                  y1="18.1295"
                  x2="20.7439"
                  y2="22.9645"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#EFF7FC" />
                  <stop offset="1" stop-color="white" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
        <div class="messenger">
          <div class="label">
            <span>Messenger</span>
          </div>
          <div class="icon">
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35 17.5C35 27.1687 27.1687 35 17.5 35C7.83125 35 0 27.1687 0 17.5C0 7.83125 7.83125 0 17.5 0C27.1687 0 35 7.83125 35 17.5Z"
                fill="#61A7FF"
              />
              <path
                d="M18.0143 11C13.5778 11 10 13.9345 10 17.5521C10 19.4495 10.9732 21.1444 12.5474 22.3587C12.8336 22.5611 12.9767 22.8647 12.9767 23.1935V24.7367C12.9767 24.9391 13.2057 25.0656 13.4061 24.9644L15.2665 24.0537C15.5242 23.9272 15.839 23.8766 16.1252 23.9525C16.7263 24.079 17.356 24.1296 17.9857 24.1296C22.4222 24.1296 26 21.195 26 17.5774C26 13.9598 22.4508 11 18.0143 11ZM22.0501 16.8691L19.102 19.8036C18.9302 19.9554 18.6726 19.9807 18.4723 19.8542L17.4705 19.1459C17.0411 18.8423 16.4687 18.7664 15.9535 18.9182L14.3506 19.3989C13.9213 19.5254 13.5492 19.07 13.864 18.7411L16.8694 15.5283C17.0411 15.3512 17.3274 15.3259 17.5277 15.4777L18.5581 16.3125C18.9875 16.6667 19.6172 16.7679 20.161 16.6161L21.5635 16.2113C21.9928 16.0849 22.3649 16.5402 22.0501 16.8691Z"
                fill="#F3FAFD"
              />
            </svg>
          </div>
        </div>
        <div class="viber">
          <div class="label">
            <span>Viber</span>
          </div>
          <div class="icon">
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35 17.5C35 27.1687 27.1687 35 17.5 35C7.83125 35 0 27.1687 0 17.5C0 7.83125 7.83125 0 17.5 0C27.1687 0 35 7.83125 35 17.5Z"
                fill="#B1A6F9"
              />
              <path
                d="M23.5315 12.4648C23.1583 12.1205 21.6502 11.0257 18.2909 11.0108C18.2909 11.0108 14.3295 10.7719 12.3984 12.5432C11.3235 13.6184 10.9453 15.1917 10.9054 17.1422C10.8655 19.0927 10.8139 22.748 14.3374 23.7391H14.3408L14.3386 25.2515C14.3386 25.2515 14.316 25.8638 14.7192 25.9887C15.2069 26.1401 15.4931 25.6748 15.9587 25.1731C16.2142 24.8977 16.5672 24.4932 16.8331 24.184C19.2429 24.3868 21.0962 23.9233 21.3067 23.8547C21.7933 23.697 24.5465 23.3443 24.9943 19.6892C25.4565 15.9218 24.7707 13.5389 23.5315 12.4648Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.3488 15.8754C18.3542 15.7706 18.4436 15.6901 18.5484 15.6956C18.9404 15.716 19.2666 15.8347 19.4989 16.0749C19.7303 16.3141 19.8437 16.6484 19.8636 17.0498C19.8688 17.1546 19.7881 17.2437 19.6833 17.2489C19.5785 17.2541 19.4893 17.1734 19.4841 17.0686C19.4671 16.725 19.3728 16.4911 19.2257 16.339C19.0796 16.1879 18.8565 16.0921 18.5286 16.075C18.4238 16.0696 18.3433 15.9802 18.3488 15.8754Z"
                fill="#B1A6F9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.0608 14.8509C18.0684 14.7463 18.1595 14.6677 18.2641 14.6753C19.0619 14.7337 19.704 15.0063 20.1718 15.5169L20.1719 15.517C20.6345 16.0225 20.8544 16.6514 20.8384 17.3891C20.8362 17.494 20.7493 17.5772 20.6444 17.5749C20.5395 17.5727 20.4563 17.4858 20.4586 17.3809C20.4727 16.7303 20.2814 16.1994 19.8916 15.7735C19.5029 15.3493 18.9597 15.1072 18.2364 15.0543C18.1317 15.0466 18.0531 14.9556 18.0608 14.8509Z"
                fill="#B1A6F9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.7255 13.8771C17.7262 13.7722 17.8118 13.6878 17.9168 13.6885C19.0193 13.6962 19.9512 14.0632 20.6994 14.7926C21.4539 15.5281 21.827 16.5294 21.8365 17.773C21.8373 17.878 21.7529 17.9637 21.648 17.9645C21.543 17.9653 21.4573 17.8808 21.4565 17.7759C21.4477 16.6106 21.101 15.7147 20.4342 15.0647C19.7611 14.4086 18.9255 14.0755 17.9141 14.0684C17.8092 14.0677 17.7247 13.9821 17.7255 13.8771Z"
                fill="#B1A6F9"
              />
              <path
                d="M18.5761 19.602C18.5761 19.602 18.8431 19.6246 18.9869 19.4474L19.2672 19.0947C19.4025 18.9199 19.7288 18.8083 20.0483 18.9863C20.2878 19.1229 20.5203 19.2714 20.7449 19.4312C20.957 19.5872 21.3913 19.9495 21.3926 19.9495C21.5995 20.1242 21.6473 20.3807 21.5064 20.6511C21.5064 20.6527 21.5053 20.6554 21.5053 20.6567C21.3502 20.9256 21.1532 21.1682 20.9218 21.3752C20.9191 21.3765 20.9191 21.3779 20.9166 21.3792C20.7156 21.5472 20.5181 21.6427 20.3242 21.6657C20.2956 21.6707 20.2666 21.6725 20.2376 21.6711C20.1521 21.6719 20.067 21.6588 19.9857 21.6323L19.9794 21.6231C19.6805 21.5388 19.1816 21.3278 18.3507 20.8695C17.8699 20.6073 17.4121 20.3049 16.9823 19.9655C16.7669 19.7955 16.5614 19.6133 16.3668 19.4197L16.3461 19.399L16.3254 19.3783L16.3046 19.3575C16.2977 19.3508 16.2909 19.3438 16.2839 19.3368C16.0904 19.1422 15.9081 18.9367 15.7381 18.7213C15.3987 18.2916 15.0964 17.8339 14.8342 17.3532C14.3758 16.522 14.1649 16.0235 14.0806 15.7243L14.0713 15.7179C14.0449 15.6366 14.0319 15.5515 14.0328 15.466C14.0312 15.437 14.033 15.408 14.038 15.3795C14.0622 15.1858 14.1578 14.9882 14.3249 14.7865C14.3262 14.7841 14.3276 14.7841 14.3289 14.7813C14.5359 14.55 14.7784 14.3531 15.0474 14.1981C15.0487 14.1981 15.0514 14.1968 15.053 14.1968C15.3234 14.0559 15.5799 14.1037 15.7543 14.3094C15.7557 14.3108 16.1174 14.7451 16.2726 14.9571C16.4325 15.182 16.581 15.4147 16.7175 15.6544C16.8955 15.9737 16.784 16.3007 16.6091 16.4355L16.2564 16.7158C16.0784 16.8596 16.1018 17.1267 16.1018 17.1267C16.1018 17.1267 16.6242 19.1038 18.5761 19.602Z"
                fill="#B1A6F9"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="body__contacts">
        <div class="label">
          <span>Або написати нам на пошту</span>
        </div>
        <div class="email">
          <span>info@xpay.com.ua</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechnicalSupport',
}
</script>

<style lang="scss" scoped>
.technical-support {
  background-color: #fff;
  border-radius: 22px;
  padding: 50px 50px 95px 50px;
  .technical-support__header {
    .header__title {
      span {
        font-size: 40px;
        font-weight: 700;
        line-height: 46px;
        color: #585f6d;
      }
    }

    .header__description {
      margin-top: 15px;
      width: 800px;
      line-height: 32px;
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        color: #67768a;
      }
    }
  }

  .technical-support__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    .body__title {
      width: 350px;
      display: flex;
      text-align: center;
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #666d79;
      }
    }

    .body__messengers {
      display: flex;
      align-items: center;
      gap: 20px;
      margin: 20px 0;
      .telegram {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 47px;
        background-color: #37aee2;
        border-radius: 48px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;

        .icon {
          position: absolute;
          top: 5px;
          right: 5px;
        }

        .label {
          margin-right: 20px;
        }
      }
      .messenger {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 47px;
        background-color: #0072ff;
        border-radius: 48px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;

        .icon {
          position: absolute;
          top: 5px;
          right: 5px;
        }

        .label {
          margin-right: 20px;
        }
      }
      .viber {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 47px;
        background-color: #7360f2;
        border-radius: 48px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;

        .icon {
          position: absolute;
          top: 5px;
          right: 5px;
        }

        .label {
          margin-right: 20px;
        }
      }
    }

    .body__contacts {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      .label {
        span {
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #666d79;
        }
      }

      .email {
        span {
          font-size: 18px;
          font-weight: 500;
          line-height: 20px;
          color: #64748B;
        }
      }
    }
  }
}
</style>
